<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <Map/> -->
    <Layout/>
  </div>
</template>

<script>
import Map from './map/map.vue'
import Layout from './layout/index'

export default {
  name: 'App',
  components: {
    Map,
    Layout
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
 
}

</style>
